var _defs, _polygon, _rect, _rect2, _rect3, _polygon2, _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraVector01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 438.68 299.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:10px;}.cls-2{fill:#241c11;opacity:.1;stroke-width:0px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "382.27 80.06 382.31 50.06 312.31 49.96 312.27 79.96 67.27 79.6 66.99 272.6 398.99 273.08 399.27 80.08 382.27 80.06"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.15,
    y: 61.81,
    width: 332,
    height: 193,
    transform: "translate(.23 -.31) rotate(.08)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 290.32,
    y: 31.98,
    width: 70,
    height: 30,
    transform: "translate(.07 -.48) rotate(.08)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 273.3,
    y: 100.51,
    width: 70,
    height: 30,
    transform: "translate(.17 -.45) rotate(.08)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "370.01 210.76 227.78 210.55 232.2 201.49 370.03 201.7 370.01 210.76"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.34,
    cy: 157.43,
    r: 82.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.34,
    cy: 157.43,
    r: 48.48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M189.77,157.54c0,2.14-.22,4.22-.63,6.24-.59,2.9-1.58,5.67-2.9,8.21-2.47,4.76-6.13,8.8-10.57,11.74-2.41,1.6-5.06,2.87-7.87,3.76-3.02.96-6.22,1.47-9.54,1.46-2.14,0-4.22-.22-6.24-.64-2.91-.57-5.67-1.57-8.23-2.89-4.75-2.48-8.8-6.13-11.73-10.57h0c-1.6-2.41-2.87-5.06-3.76-7.86-.95-3.01-1.47-6.22-1.46-9.54,0-2.14.22-4.22.63-6.24.59-2.9,1.58-5.67,2.91-8.21,2.47-4.75,6.11-8.78,10.53-11.73,0,0,.03-.02.04-.02,2.41-1.6,5.06-2.88,7.87-3.76,3.01-.96,6.21-1.47,9.53-1.46,2.14,0,4.22.22,6.24.64,2.91.57,5.67,1.57,8.23,2.89,4.75,2.48,8.8,6.13,11.73,10.57h0c1.6,2.41,2.87,5.06,3.76,7.86.95,3.01,1.47,6.22,1.46,9.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraVector01);
export default __webpack_public_path__ + "static/media/Camera Vector-01.d58767f617088f16915aed8ef156782a.svg";
export { ForwardRef as ReactComponent };